const getPlatform = (): string => {
  let platform = ''

  if (!platform) {
    platform = /iPhone|iPod|Android/i.test(navigator.userAgent)
      ? 'web-mobile'
      : 'web-desktop'
  }

  return platform
}

export default getPlatform
